import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FallaufgabeLernbegleiter, FallAufgabenStatus, TeilaufgabenSolution } from '@reflact/ipkv-types';
import { BehaviorSubject, firstValueFrom, Subject } from 'rxjs';
import { PasteTrackingService } from './paste-tracking.service';
@Injectable({
  providedIn: 'root'
})
export class Api {
  private http = inject(HttpClient);
  private pasteTracking = inject(PasteTrackingService);

  public fallaufgabe?: FallaufgabeLernbegleiter;
  public fallaufgabeStatus?: FallAufgabenStatus | null;
  public solutions = new BehaviorSubject<TeilaufgabenSolution[]>([]);
  public fallaufgabenStatusSubject: Subject<FallAufgabenStatus> = new Subject()

  public async loadFallaufgabe() {
    const result = await firstValueFrom(this.http.get<{ fallaufgabe: FallaufgabeLernbegleiter, fallaufgabeStatus: FallAufgabenStatus | null, botLink: string }>('api/fallaufgabe'));
    this.fallaufgabe = result.fallaufgabe;
    this.fallaufgabe.aufgaben.sort((a, b) => a.aufgabenIndex - b.aufgabenIndex);
    this.fallaufgabeStatus = result.fallaufgabeStatus;
    if (this.fallaufgabeStatus) {
      this.fallaufgabenStatusSubject.next(this.fallaufgabeStatus);
    }
  }

  public async getCurrentSolutions(): Promise<void> {
    const result = await firstValueFrom(this.http.get<{ status: FallAufgabenStatus, solutions: TeilaufgabenSolution[] }>('api/interact/solutions'));
    this.solutions.next(result.solutions);
  }

  public async checkConnection(): Promise<boolean> {
    try {
      await firstValueFrom(this.http.get<{ status: FallAufgabenStatus, solutions: TeilaufgabenSolution[] }>('api/fallaufgabe', { timeout: 3000 }));
      return true;
    } catch (e) {
    }
    return false
  }

  public async start() {
    return await firstValueFrom(this.http.post('api/start', {}));
  }

  public async trackCopyEvent(
    teilaufgabenId: string,
    aufgabenId: string | null,
    contentType: 'frage' | 'antwort' | 'sonstiges' = 'frage'
  ) {
    return await firstValueFrom(this.http.post('api/interact/copyevent', {
      teilaufgabenId,
      aufgabenId,
      contentType,
    }));
  }

  public async submitFallaufabe() {
    return await firstValueFrom(this.http.post('api/interact/submit', { inputMetadata: this.pasteTracking.getAndResetDelta() }));
  }

  public async getViewForApiResult() {
    await this.loadFallaufgabe();
    if (this.fallaufgabeStatus == null && this.fallaufgabe != null) {
      return "introduction"; // nutzer hat noch nicht begonnen
    }
    if (this.fallaufgabeStatus != null && this.fallaufgabe != null) {
      return "lernbegleiter";
    }
    if (this.fallaufgabeStatus != null && this.fallaufgabe == null) {
      return "expired"; // nutzer hat noch nicht begonnen
    }
    console.warn("no valid redirect for", { fallaufgabe: this.fallaufgabe, status: this.fallaufgabeStatus })
    return "notfound"
  }

  public async saveTableCell(teilaufgabenId: string, row: number, col: number, content: string) {
    const inputMetadata = this.pasteTracking.getAndResetDelta();
    const result = await firstValueFrom(this.http.post<TeilaufgabenSolution>('api/interact/savetablecell', { teilaufgabenId, row, col, content, inputMetadata }));
    await this.getCurrentSolutions();
  }
}